import { ICustomProperties, IEventTelemetry } from "@microsoft/applicationinsights-web";

export class FeedbackGiven implements IEventTelemetry {
    name: string = "FeedbackGiven";
    input: string;

    constructor(input: string) {
        this.input = input;
    }

    public getCustomProperties = (): ICustomProperties => {
        return {
            input: this.input
        };
    };
}
